const $ = jQuery.noConflict();
/* eslint-disable */
import Global from '../shared/global';
import FormHelpers from './formHelpers';
// 1309b Avenue J, Brooklyn, NY, USA
let autocomplete;
let autocomplete2;
let autocomplete3;
let address2Field;
let postalField;
let autocompleteCurrent;
let addressFieldCurrent;
let postcode = '';
let allowedPostCodes = [];
const dataAddress = {};
let postcodeFilled = false;

'use strict';
const LocationSearch = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.initAutocompleteWidget();
		this.autocompleteValidation();
		this.cancelPopup();
		this.saveLocation();
		this.zipEnter();
		$('.js-location-enter').on('focus', function() {
			$('.js-location-enter').removeClass('active');
			$(this).addClass('active');
		});
	},


	// init autocomplete
	initAutocompleteWidget: function() {
		const address1Field = document.querySelector('.js-location-search');
		console.log(address1Field);
		const address1Field2 = document.querySelector('.js-location-search-form');
		const address1Field3 = document.querySelector('.js-location-search-vue');
		if (!address1Field && !address1Field2 && !address1Field3) {
			return;
		}
		// Create the autocomplete object, restricting the search predictions to
		// addresses in the US and Canada.

		if (address1Field) {
			// eslint-disable-next-line no-undef
			autocomplete = new google.maps.places.Autocomplete(address1Field, {
				componentRestrictions: {country: ['us']},
				fields: ['adr_address', 'formatted_address', 'name', 'address_components', 'plus_code', 'geometry'],
				types: ['postal_code'],
			});
		}

		if (address1Field2) {
			// eslint-disable-next-line no-undef
			autocomplete2 = new google.maps.places.Autocomplete(address1Field2, {
				componentRestrictions: {country: ['us']},
				fields: ['adr_address', 'formatted_address', 'name', 'address_components', 'plus_code', 'geometry'],
				types: ['postal_code'],
			});
		}

		if (address1Field3) {
			// eslint-disable-next-line no-undef
			autocomplete3 = new google.maps.places.Autocomplete(address1Field3, {
				componentRestrictions: {country: ['us']},
				fields: ['adr_address', 'formatted_address', 'name', 'address_components', 'plus_code', 'geometry'],
				types: ['address'],
			});
		}


		if (document.body.classList.contains('page-template-page-booking-steps')) {
			if (address1Field3) {
				address1Field3.focus();
			}

			if (address1Field2) {
				address1Field2.focus();
			}
		}

		// When the user selects an address from the drop-down, populate the
		// address fields in the form.
		if (address1Field) {
			address1Field.addEventListener('change', function() {
				addressFieldCurrent = address1Field;

				if (document.body.classList.contains('page-template-page-booking-steps')) {
					address2Field = document.querySelector('.address2');
					postalField = document.querySelector('.postal_code');
				} else {
					address2Field = address1Field.parentElement.querySelector('.address2');
					postalField = address1Field.parentElement.querySelector('.postal_code');
				}
				address2Field = document.querySelector('.address2');
				postalField = document.querySelector('.postal_code');
				LocationSearch.passAutoComplete(autocomplete);
			});
		}

		if (address1Field3) {
			address1Field3.addEventListener('change', function() {
				addressFieldCurrent = address1Field3;

				if (document.body.classList.contains('page-template-page-booking-steps')) {
					address2Field = document.querySelector('.address2');
					postalField = document.querySelector('.postal_code');
				} else {
					address2Field = address1Field.parentElement.querySelector('.address2');
					postalField = address1Field.parentElement.querySelector('.postal_code');
				}
				address2Field = document.querySelector('.address2');
				postalField = document.querySelector('.postal_code');
				LocationSearch.passAutoComplete(autocomplete3);
			});
		}

		if (address1Field2) {
			address1Field2.addEventListener('change', function() {
				addressFieldCurrent = address1Field2;
				address2Field = address1Field2.parentElement.querySelector('.address2');
				postalField = address1Field2.parentElement.querySelector('.postal_code');
				LocationSearch.passAutoComplete(autocomplete2);
			});
		}
	},

	// pass autocomplete instance
	passAutoComplete: function(obj) {
		autocompleteCurrent = obj;
		autocompleteCurrent.addListener('place_changed', LocationSearch.fillInAddress);
	},

	// prepare address object
	fillInAddress: function() {
		// Get the place details from the autocomplete object.
		const place = autocompleteCurrent.getPlace();
		let address1 = '';
		postcode = '';
		allowedPostCodes = addressFieldCurrent.getAttribute('data-codes');
		allowedPostCodes = allowedPostCodes.split(',');
		if (document.body.classList.contains('page-template-page-booking-steps')) {
			document.querySelector('.postal_code').value = '';
			document.querySelector('.postal_code').classList.remove('filled');
			document.querySelector('#locality').value = '';
			document.querySelector('#locality').classList.remove('filled');
			document.querySelector('#administrative_area_level_1').value = '';
			document.querySelector('#administrative_area_level_1').classList.remove('filled');
		} else {
			addressFieldCurrent.parentElement.querySelector('.postal_code').value = '';
		}

		// Get each component of the address from the place details,
		// and then fill-in the corresponding field on the form.
		// place.address_components are google.maps.GeocoderAddressComponent objects
		// which are documented at http://goo.gle/3l5i5Mr
		for (const component of place.address_components) {
			const componentType = component.types[0];
			switch (componentType) {
				case 'street_number': {
					address1 = `${component.long_name} ${address1}`;
					dataAddress['street_number'] = `${component.long_name} ${address1}`;
					break;
				}

				case 'route': {
					address1 += component.short_name;
					dataAddress['route'] = component.short_name;
					break;
				}

				case 'postal_code': {
					postcode = component.long_name;
					if (document.body.classList.contains('page-template-page-booking-steps')) {
						const postalCodeField = document.querySelector('.postal_code');
						postalCodeField.value = component.long_name;
						if (component.long_name !== '') {
							postalCodeField.classList.add('filled');
						}
					}
					dataAddress['postal_code'] = `${postcode}`;
					break;
				}

				// case 'postal_code_suffix': {
				// 	postcode = `${postcode}-${component.long_name}`;
				// 	dataAddress['postal_code_suffix'] = `${postcode}-${component.long_name}`;
				// 	break;
				// }
				case 'locality': {
					const localityField = document.querySelector('#locality');
					localityField.value = component.long_name;
					if (component.long_name !== '') {
						localityField.classList.add('filled');
					}
					dataAddress['locality'] = component.long_name;
					break;
				}

				case 'political': {
					const localityField = document.querySelector('#locality');
					localityField.value = component.long_name;
					if (component.long_name !== '') {
						localityField.classList.add('filled');
					}
					dataAddress['locality'] = component.long_name;
					break;
				}

				case 'sublocality_level_1': {
					const localityField = document.querySelector('#locality');
					localityField.value = component.long_name;
					if (component.long_name !== '') {
						localityField.classList.add('filled');
					}
					dataAddress['locality'] = component.long_name;
					break;
				}

				case 'sublocality': {
					const localityField = document.querySelector('#locality');
					localityField.value = component.long_name;
					if (component.long_name !== '') {
						localityField.classList.add('filled');
					}
					dataAddress['locality'] = component.long_name;
					break;
				}

				case 'administrative_area_level_1': {
					const administrativeAreaLevel1 = document.querySelector('#administrative_area_level_1');
					if (administrativeAreaLevel1) {
						administrativeAreaLevel1.value = component.short_name;
						if (component.short_name !== '') {
							administrativeAreaLevel1.classList.add('filled');
						}
					}

					dataAddress['administrative_area_level_1'] = component.short_name;
					break;
				}
				case 'country':
					dataAddress['country'] = component.long_name;
					break;
				default:
			}
		}
		postalField.value = postcode;
		dataAddress['full_address'] = addressFieldCurrent.value;
		dataAddress['apartment'] = '';
		// After filling the form with address components from the Autocomplete
		// prediction, set cursor focus on the second address line to encourage
		// entry of supreme information such as apartment, unit, or floor number.
		if (document.body.classList.contains('page-template-page-booking-steps')) {
			address2Field.focus();
			Global.setCookie('address', dataAddress);
		}
	},

	// check if post code is allowed for delivery (in dashboard theme settings are listed post codes)
	checkPostCode: function(postcode, allowedPostCodes, email) {
		let flag = false;
		const currentSearchInput = document.querySelector('.js-location-enter.active');
		if (currentSearchInput) {
			if (postcode === '') {
				postcode = currentSearchInput.value;
				allowedPostCodes = currentSearchInput.getAttribute('data-codes');
				allowedPostCodes = allowedPostCodes.split(',');
			}
		}
		if (allowedPostCodes) {
			for (let i = 0; i < allowedPostCodes.length; i++) {
				if (!allowedPostCodes.includes(postcode)) {
					flag = true;
				}
			}
		}
		console.log(postcode, !allowedPostCodes.includes(postcode), flag);
		if (postcode === '' || !allowedPostCodes.includes(postcode) || flag) {
			const popupTrigger = document.querySelector('.js-pu-re-trigger');
			popupTrigger.click();
			if (email !== '') {
				const popupEmail = document.querySelector('.js-restricted-email');
				popupEmail.value = email;
			}
		} else {
			const data = {
				action: 'booking_started',
				email: email
			};
			LocationSearch.ajaxFunc(data);
		}
	},

	zipEnter: function() {
		// Get the input field
		const inputs = document.querySelectorAll('.js-location-enter');

		if (inputs.length < 1) {
			return false;
		}
		const eventNew = document.createEvent('Event');
		eventNew.initEvent('change', false, true);

		const triggerEnter = function(event) {
			const _this = this;
			this.focus();
			// If the user presses the "Enter" key on the keyboard
			if (event.key === 'Enter') {
				// Cancel the default action, if needed
				event.preventDefault();
				// args: string type, boolean bubbles, boolean cancelable
				this.dispatchEvent(eventNew);
				// Trigger the button element with a click
				setTimeout(function() {
					if (_this.classList.contains('js-location-search-form')) {
						document.querySelector('.js-next-location-form-bottom').click();
					} else {
						document.querySelector('.js-next-location-form-top').click();
					}

				}, 500);
			}
		};

		for (let i = 0; i < inputs.length; i++) {
			// Execute a function when the user presses a key on the keyboard
			inputs[i].addEventListener('keypress', triggerEnter);
			inputs[i].addEventListener('change', triggerEnter);
		}


	},

	// save location popup event
	saveLocation: function() {
		const btn = document.querySelector('.js-restricted-submit');
		if (!btn) {
			return;
		}
		const email = document.querySelector('.js-restricted-email');
		const loaderBtn = document.querySelector('.js-btn-loader');
		btn.addEventListener('click', function() {
			const validationError = document.querySelector('.js-validation-error-popup');
			// validate email in popup
			if (email.value.length < 1) {
				validationError.innerHTML = 'Email field is empty';
				return;
			}
			if (!LocationSearch.emailValidation(email.value)) {
				validationError.innerHTML = 'Email is not valid';
				return;
			}
			dataAddress['email'] = email.value;
			const locationSearchInput = document.querySelector('.js-location-search');
			const postalCode = document.getElementById('postal_code');
			dataAddress['full_address'] = locationSearchInput.value;
			dataAddress['postal_code'] = postalCode.value;
			const data = {
				action: 'restricted_area',
				address: dataAddress,
			};
			loaderBtn.classList.add('active-loader');
			this.style.fontSize = '0';
			LocationSearch.ajaxFunc(data);
		});

	},

	// trigger close popup
	cancelPopup: function() {
		const btn = document.querySelector('.js-restricted-cancel');
		if (!btn) {
			return;
		}
		btn.addEventListener('click', function() {
			LocationSearch.triggerCancelPopup();
		});
	},

	triggerCancelPopup: function() {
		const popup = document.querySelector('.js-pu-re');
		const popupCancel = popup.querySelector('.fancybox-close-small');
		popupCancel.click();
	},

	// ajax function
	ajaxFunc: function(data) {
		$.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			data: data,
			success: (response) => {
				console.log(response);
				if (response.data.action === 'start_booking') {
					// Global.setCookie('address', dataAddress);
					location.href = response.data.url;
				}
				if (response.data.action === 'restricted_area') {
					// alert('You have successfully submitted an email. You will be notified when your area becomes available.');
					const popup = document.querySelector('.js-successfull-popup');
					popup.classList.add('popup-active');
					LocationSearch.triggerCancelPopup();
					setTimeout(function() {
						const popup = document.querySelector('.js-successfull-popup');
						popup.classList.remove('popup-active');
					}, 2000);
					const btn = document.querySelector('.js-restricted-submit');
					const loaderBtn = document.querySelector('.js-btn-loader');
					btn.style.fontSize = '20px';
					loaderBtn.classList.remove('active-loader');
				}
			}
		});
	},

	// autocomplete validation
	autocompleteValidation: function() {
		const buttons = document.getElementsByClassName('js-next-location-form');
		if (!buttons) {
			return;
		}

		let location;
		let email;
		let hasEmail;
		const validationErrorPopup = document.querySelector('.js-validation-error-popup');
		const validationErrorBanner = document.querySelector('.js-validation-error-banner');
		const validationErrorBasicForm = document.querySelector('.js-validation-error-basic-form');
		for (let i = 0; i < buttons.length; i++) {
			buttons[i].addEventListener('click', function(e) {
				if (validationErrorPopup) {
					validationErrorPopup.innerHTML = '';
				}
				if (validationErrorBanner) {
					validationErrorBanner.innerHTML = '';
				}
				if (validationErrorBasicForm) {
					validationErrorBasicForm.innerHTML = '';
				}
				buttons[i].classList.remove('js-allow');
				if (buttons[i].classList.contains('js-form')) {
					hasEmail = true;
					email = buttons[i].parentElement.parentElement.querySelector('#your-email');
					location = buttons[i].parentElement.parentElement.querySelector('.js-location');
				}
				if (buttons[i].classList.contains('js-no-form')) {
					hasEmail = false;
					location = buttons[i].parentElement.querySelector('.js-location');
				}
				if (hasEmail) {
					if (email.value.length < 1) {
						validationErrorBasicForm.innerHTML = 'Email field is empty.';
						return;
					}
					if (!LocationSearch.emailValidation(email.value)) {
						validationErrorBasicForm.innerHTML = 'Email Is not valid.';
						return;
					}
					if (location.value.length < 1) {
						validationErrorBasicForm.innerHTML = 'Location field is empty.';
						return;
					}
				} else {
					if (location.value.length < 1) {
						validationErrorBanner.innerHTML = 'Location field is empty.';
						return;
					}
				}
				buttons[i].classList.add('js-allow');
				LocationSearch.checkPostCode(postcode, allowedPostCodes, email ? email.value : email = '');

			});
		}
	},

	// validate email
	emailValidation: function(email) {
		const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}

};

export default LocationSearch;
